import { render } from "./App.vue?vue&type=template&id=17dadc67"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=17dadc67&lang=css"

import exportComponent from "../.yarn/__virtual__/vue-loader-virtual-5e85c868fe/4/.yarn/berry/cache/vue-loader-npm-17.4.2-00674d01e5-10c0.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__